// src/pages/orders/adminPagesPage.js — CMS pages management (commerce engine)
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card, CardBody, CardHeader } from "../../components/card/card.jsx";
import { fetchAdminPages, saveAdminPage } from "../../actions/commerce_admin_actions";

function PageEditor({ page }) {
  const dispatch = useDispatch();
  const [title, setTitle] = useState(page.title || "");
  const [content, setContent] = useState(page.content || "");
  return (
    <Card className="mb-3">
      <CardHeader><strong>/{page.slug}</strong> <span className="text-inverse text-opacity-50 small">· type {page.pageType || "—"}</span></CardHeader>
      <CardBody>
        <input className="form-control mb-2" placeholder="title" value={title} onChange={(e) => setTitle(e.target.value)} />
        <textarea className="form-control mb-2" rows={4} placeholder="content" value={content} onChange={(e) => setContent(e.target.value)} />
        <button className="btn btn-outline-theme btn-sm" onClick={() => dispatch(saveAdminPage({ id: page.id, slug: page.slug, title, content, pageType: page.pageType }))}>Save page</button>
      </CardBody>
    </Card>
  );
}

export default function AdminPages() {
  const dispatch = useDispatch();
  const { adminPages, adminLoading, adminError, adminSaveError } = useSelector((s) => s.commerceAdmin);
  const [slug, setSlug] = useState("");

  useEffect(() => { dispatch(fetchAdminPages()); }, [dispatch]);

  return (
    <div>
      <h1 className="page-header mb-1">CMS Pages</h1>
      <div className="text-inverse text-opacity-50 mb-3">Content served by the commerce engine</div>
      {adminError ? <div className="alert alert-danger">{adminError}</div> : null}
      {adminSaveError ? <div className="alert alert-warning">Save failed — {adminSaveError}</div> : null}

      <Card className="mb-3">
        <CardHeader>Add a page</CardHeader>
        <CardBody>
          <div className="d-flex gap-2 align-items-center">
            <input className="form-control" style={{ maxWidth: 260 }} placeholder="slug" value={slug} onChange={(e) => setSlug(e.target.value)} />
            <button className="btn btn-theme" disabled={!slug} onClick={() => { dispatch(saveAdminPage({ slug, title: slug, content: "" })); setSlug(""); }}>Create</button>
          </div>
        </CardBody>
      </Card>

      {adminLoading ? <div className="text-center py-3">Loading…</div> : null}
      {adminPages.map((p) => <PageEditor key={p.id} page={p} />)}
    </div>
  );
}
